// extracted by mini-css-extract-plugin
module.exports = {"root":"RivenditoreForm_root__C3927","container":"RivenditoreForm_container__guuC9","rotation":"RivenditoreForm_rotation__YR_h3"};